"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fileExtensionFromFilename(filename) {
    if (!filename) {
        return undefined;
    }
    const idx = filename.lastIndexOf(".");
    if (idx === -1) {
        return undefined;
    }
    const ext = filename.substring(idx + 1);
    if (ext.length > 4) {
        return undefined;
    }
    return ext.toUpperCase();
}
exports.default = fileExtensionFromFilename;
